(function ($) {
  function bodyClass() {
    if ($('[name="custom-template"]').length) {
      $("body").addClass($('[name="custom-template"]').val());
    }
  }

  function menu() {
    var currentFlyout = "",
      onFlyout = 0;
    $(".primary a[data-foname]").on("mouseenter", function () {
      var $this = $(this);
      currentFlyout = $this.data("foname");
      $(".flyout").hide();
      $('.flyout[data-flyout="' + currentFlyout + '"]').show();

      $this.parent().siblings().removeClass("hover");
      $this.parent().addClass("hover");
    });

    $(".flyout[data-flyout]")
      .on("mouseenter", function () {
        onFlyout = 1;
      })
      .on("mouseleave", function () {
        // console.log('outside primary....... ' + onFlyout );
        if (onFlyout == 1) {
          $(".flyout").hide();
          onFlyout = 0;
          $(".primary .hover").removeClass("hover");
        }
      });

    $(".primary").on("mouseleave", function () {
      // console.log('outside primary....... ' + onFlyout );
      setTimeout(function () {
        if (onFlyout == 0) {
          $(".flyout").hide();
          onFlyout = 0;
          $(".primary .hover").removeClass("hover");
        }
      }, 300);
    });

    if ($(".widget.menu").length) {
      $(".widget.menu .menu-normal").clone().appendTo($(".mob-menu-widget"));

      $(".mob-menu-widget .current-item").on("click", function () {
        $(this).parent().toggleClass("active");
      });
    }

    $(".toggle-sub").on("click", function () {
      var $this = $(this);
      if ($this.hasClass("active")) {
        $this.removeClass("active");
        $this.next(".sub-menu").slideUp("fast");
      } else {
        $this.addClass("active");
        $this.next(".sub-menu").slideDown("fast");
      }
      return false;
    });

    $(".toggle-mobile").on("click", function () {
      $(".mobile-menu").fadeIn("fast");
      $("body").addClass("mob-menu-active");
      return false;
    });

    $(".close-mob-menu").on("click", function () {
      $(".mobile-menu").fadeOut("fast");
      $("body").removeClass("mob-menu-active");
      return false;
    });

    $(".toggle-search").on("click", function () {
      var $this = $(this);
      if ($this.hasClass("active")) {
        $this.removeClass("active");
      } else {
        $this.addClass("active");
        setTimeout(function () {
          $(".search-form-pop input").focus();
        }, 500);
      }
      return false;
    });
  }

  function slider() {
    if ($(".testi-slider").length) {
      $(".testi-slider").slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
      });
    }

    if ($(".prod-figs-la").length) {
      $(".prod-figs-la").slick({
        arrows: false,
        dots: false,
        infinite: true,
        fade: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        asNavFor: ".prod-figs-sm",
      });
    }

    if ($(".prod-figs-sm").length) {
      $(".prod-figs-sm").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".prod-figs-la",
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        prevArrow: '<span class="prev"></span>',
        nextArrow: '<span class="next"></span>',
      });
    }
  }

  function innateChoice() {
    if ($(".tab-products").length) {
      $(".tab-products a").on("click", function () {
        var $this = $(this);
        $("html, body").animate(
          {
            scrollTop: $(
              '[data-product="' + $this.data("jumpto") + '"]'
            ).offset().top,
          },
          600
        );
        return false;
      });
    }
  }

  function qty() {
    $(document).on("click", ".custom-qty .minus", function () {
      var $input = $(this).parent().find("input");
      var count = parseInt($input.val()) - 1;
      count = count < 1 ? 0 : count;
      $input.val(count);
      // console.log( 'count minus ' + count );
      $input.change();
      return false;
    });

    $(document).on("click", ".custom-qty .plus", function () {
      var $input = $(this).parent().find("input");
      $input.val(parseInt($input.val()) + 1);
      // console.log( 'count plus ' + parseInt($input.val()) + 1 );
      $input.change();
      return false;
    });

    // if( $('.custom-qty').length ){
    //     $('.custom-qty').each(function(){
    //         var $this = $(this);
    //         var $id = $this.find('input').attr('id');
    //         // $(document).on('click', $id +'> .minus', function(){
    //         $this.children('.minus').on('click',function () {
    //             var $input = $(this).parent().find('input');
    //             var count = parseInt($input.val()) - 1;
    //             count = count < 1 ? 0 : count;
    //             $input.val(count);
    //             // console.log( 'count minus ' + count );
    //             $input.change();
    //             return false;
    //         });
    //         // $(document).on('click', $id + '> .plus', function(){
    //         $this.children('.plus').on('click',function () {
    //             var $input = $(this).parent().find('input');
    //             $input.val(parseInt($input.val()) + 1);
    //             // console.log( 'count plus ' + parseInt($input.val()) + 1 );
    //             $input.change();
    //             return false;
    //         });
    //     });
    // }
  }

  if ($(".promo-case").length) {
    var promoCase = $(".promo-case");
    let numberP = $(".cart__qty-input").val();
    // console.log(`I'm here!!!!  ${numberP}`);
    var currentCase = parseInt($("#current-case").val());
    // console.log( 'currentCase ' + currentCase );
    /*
        $(document).on('change','.custom-qty input',function(){
            // var itemURL = $(this).parents('tr').data('cart-item-url');
            // if( itemURL.indexOf("case") > -1 ){

            // }
            // console.log( $(this).parents('tr').data('cart-item-url') );
            var currentCase = 0;
            setTimeout(function(){
                $('tbody[data-cart-line-items] tr[data-cart-item-eligible=""]').each(function(){
                    var $tr = $(this);
                    // console.log( 'cart__product-title ' + $tr.find('.cart__product-title').text() );
                    // var itemURL = $tr.data('cart-item-url');
                    currentCase = currentCase + parseInt( $tr.find('input[type="number"]').val() );
                });

                console.log( 'currentCase ' + currentCase );

                if( currentCase < 5 ){
                    promoCase.find('h5').empty().text( promoCase.data('less').replace("[number]", ( 5 - currentCase ) ) );
                    promoCase.find('.track').css('left', ( currentCase * 100 / 5 ) + '%' );
                }else{
                    promoCase.find('h5').empty().text( promoCase.data('equal') );
                    promoCase.find('.track').css('left', '100%' );
                }
            },1000);
        });*/
  }

  function prodWithUpsell() {
    if ($(".push-upsell").length) {
      $("section.upsells .list").removeAttr("style");
      $("#MainContent").removeAttr("style");

      var mainHeight = $("#MainContent").outerHeight();
      var upsellsHeight = $("section.upsells .list").outerHeight();
      // console.log( 'mainHeight ' + mainHeight );
      // console.log( 'upsellsHeight ' + upsellsHeight );
      if (upsellsHeight > mainHeight) {
        $("#MainContent").css(
          "minHeight",
          $("section.upsells .list").outerHeight() + "px"
        );
      } else {
        $("section.upsells .list").css(
          "minHeight",
          $("#MainContent").outerHeight() + "px"
        );
      }
    }

    if ($(".with-suggestions").length) {
      var withSuggestions = $(".with-suggestions"),
        prodSuggestions = $(".cart-suggestions > div");

      withSuggestions.removeAttr("style");
      prodSuggestions.removeAttr("style");

      if (prodSuggestions.outerHeight() > withSuggestions.outerHeight()) {
        withSuggestions.css("minHeight", prodSuggestions.outerHeight() + "px");
        prodSuggestions.css("minHeight", prodSuggestions.outerHeight() + "px");
        prodSuggestions
          .find(".bg")
          .css("minHeight", prodSuggestions.outerHeight() + "px");
      } else {
        withSuggestions.css("minHeight", withSuggestions.outerHeight() + "px");
        prodSuggestions.css("minHeight", withSuggestions.outerHeight() + "px");
        prodSuggestions
          .find(".bg")
          .css("minHeight", withSuggestions.outerHeight() + "px");
      }
    }
  }

  function products() {
    $(".custom-sort").change(function () {
      $this = $(this);
      // console.log( $this.val() );
      $this.parent().submit();
    });

    $(".list-buy-now").on("click", function () {
      // console.log( 'list buy now.......' );
      var $this = $(this);

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: $this.data("prod_id"),
        },
        success: function () {
          // console.log('product ' + $this.data('prod_id') + ' successfully added!');
          // alert( 'Successfully added to the cart!' );
          window.location.href = "/cart";
          cartCount(); // update cart
          // console.log('cart count: ' + cartCount() );
        },
        error: function () {
          alter.log(
            "Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available."
          );
        },
      });
      return false;
    });

    $(".list-to-cart").on("click", function () {
      var $this = $(this),
        qty = $(this).prev().find("input").val();

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: qty,
          id: $this.data("prod_id"),
        },
        success: function () {
          window.location.href = "/cart";
          cartCount(); // update cart
        },
        error: function () {
          alter.log(
            "Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available."
          );
        },
      });
      return false;
    });

    $(".more-scroll").on("click", function () {
      $("html, body").animate(
        {
          scrollTop: $(".event-tabs").offset().top,
        },
        600
      );
      return false;
    });

    $(".e-tabs a").on("click", function () {
      var $this = $(this),
        content = $(".e-content");

      content.hide();
      $this.siblings().removeClass("current");

      $(".mob-tab").removeClass("current");
      $('.mob-tab[data-target="' + $this.data("target") + '"]').addClass(
        "current"
      );

      $this.addClass("current");
      $("#" + $this.data("target")).show();
      return false;
    });

    $(".mob-tab").on("click", function () {
      $('.e-tabs a[data-target="' + $(this).data("target") + '"]').trigger(
        "click"
      );
    });

    if ($(".product-tabs").length) {
      $(".e-tabs a:first").trigger("click");
    }

    $(".faq-head").on("click", function () {
      $(this).parent(".item").toggleClass("active");
      $(this).next().slideToggle();
    });

    $(".anchors a").on("click", function () {
      var $this = $(this);

      console.log("target " + $this.data("target"));

      $("html, body").animate(
        {
          scrollTop: $(".product-tabs").offset().top,
        },
        600
      );

      setTimeout(function () {
        $('.e-tabs a[data-target="' + $this.data("target") + '"]').trigger(
          "click"
        );
      }, 600);
      return false;
    });
  }

  function cartCount() {
    $.getJSON("/cart.js", function (cart) {
      // console.log( cart );
      $("span[data-cart-count]")
        .text(cart.item_count)
        .attr("data-cart-count", cart.item_count);
      // alert('There are now ' + cart.item_count + ' items in the cart.');
    });
  }

  var reviewRun = 1;
  function updateReviews() {
    if ($("#shopify-product-reviews").length && reviewRun == 1) {
      setTimeout(function () {
        if ($(".event-card").length) {
          $(".spr-header-title").text("Certification Seminar Reviews");
        }
        $(".spr-review").each(function () {
          var $this = $(this);

          $this
            .find(".spr-review-header-byline")
            .prependTo($this.find(".spr-review-footer"));
        });
      }, 1000);
      reviewRun = 0;
    }
  }

  function getCartItems() {
    var cartItems = [];

    $.getJSON("/cart.js", function (cart) {
      // now have access to Shopify cart object
      // alert('There are now ' + cart.item_count + ' items in the cart.');
      if (cart.items) {
        for (var i = 0; i < cart.items.length; i++) {
          product = cart.items[i];
          // console.log( product.id );
          cartItems.push(product.id);
        }
        // console.log( 'cartItems ----- ' );
        // console.log( cartItems );
      }
    });

    return cartItems;
  }

  function clearCart() {
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        console.log("You cleared the cart!");
      },
    });
  }

  function bulkOrders() {
    if ($(".dashboard .products").length) {
      // console.log( 'bulkOrders init.... ' );

      $(".bulk-totals").clone().addClass("sticky").appendTo($("#MainContent"));

      var currentProdInCart = getCartItems(),
        $ids = [];

      // console.log( 'currentProdInCart --- ' );
      // console.log( currentProdInCart );

      $(".products-to-cart").on("click", function () {
        // console.log( 'bulkOrders btn init.... ' );
        if ($ids.length == 0 && currentProdInCart.length == 0) {
          $("html, body").animate(
            {
              scrollTop: $(".dash-head").offset().top,
            },
            600
          );

          $(".dash-error").append("<div>Please add products.</div>");

          setTimeout(function () {
            $(".dash-error > div").slideUp().delay(500).remove();
          }, 3000);
          return false;
        }

        $(".dashboard").addClass("loading");

        // clearCart();

        var counter = 0;

        // console.log( '---------- ids' );
        // console.log( $ids );
        // console.log( '---------- ids' );

        Shopify.queue = [];
        for (var i = 0; i < $ids.length; i++) {
          product = $ids[i];
          // console.log( '******** id - ' + product.pid );
          // console.log( '******** qty - ' + product.qty );
          Shopify.queue.push({
            variantId: product.pid,
            variantQty: product.qty,
          });
        }

        // console.log( '==================Shopify.queue=========' );
        // console.log( Shopify.queue );
        // console.log( '==================Shopify.queue=========' );

        setTimeout(function () {
          Shopify.moveAlong = function () {
            // If we still have requests in the queue, let's process the next one.
            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var data =
                "id=" + request.variantId + "&quantity=" + request.variantQty;

              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: data,
                success: function (res) {
                  Shopify.moveAlong();
                  // console.log('successfully added - ' + request.variantId );
                  // currentProdInCart = getCartItems();
                  // console.log( currentProdInCart );
                  // updateBagTotal();
                },
              });
            }

            if ($ids.length == counter) {
              // $this.parent().removeClass('loading');
              setTimeout(function () {
                $(".dashboard").removeClass("loading");
                updateBagTotal();
                window.location.href = "/cart";
                // console.log(['should redirect now...........']);
              }, 1000);
            }

            counter++;
          };
          Shopify.moveAlong();
        }, 1000);

        return false;
      });

      $(".box-list .custom-qty input").on("change", function () {
        // var $this = $(this);
        // console.log( 'qty scrolled ' + $this.val() );
        var total = 0;
        $ids = [];

        $(".bulk-totals.sticky .items").empty();

        $(".list .item").each(function () {
          var price = $(this)
              .find(".price__regular .price-item")
              .text()
              .replace(/\s+/g, " ")
              .trim()
              .substr(1),
            qty = $(this).find("input[type=number]").val(),
            pid = $(this).find("input[type=number]").data("pid");
          if (qty > 0) {
            // console.log('qty: ' + qty + ' ---- price: ' + price );
            total += qty * price;
            $ids.push({ pid: pid, qty: qty });
            $(".bulk-totals.sticky .items")
              .addClass("above-1")
              .append(
                "<span>" + qty + " x " + $(this).find("a").text() + "</span>"
              );
          }
        });
        // console.log( 'total ' + total.toFixed(2) );
        $(".bulk-totals .total-price").text(
          "$" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
        );

        if ($ids === undefined || $ids.length == 0) {
          $(".bulk-totals.sticky .items").removeClass("above-1");
        }
      });
    }
  }

  function updateBagTotal() {
    setTimeout(function () {
      $.getJSON("/cart.js", function (response) {
        // console.log( response );
        if (response) {
          if (response.item_count > 0) {
            $(".tertiary .menu-cart-count").empty().text(response.item_count);
          } else {
            $(".tertiary .menu-cart-count").text("0");
          }

          // console.log('----------------------------------------------- bag updated');
        }
      });
    }, 600);
  }

  function account() {
    if ($(".mobile-sidenav").length) {
      $("aside ul").clone().appendTo($(".mobile-sidenav"));
      $(".mobile-sidenav .active").text($("aside .current").text());
    }

    $(".edit-addr").on("click", function () {
      var fid = "#" + $(this).attr("aria-owns");
      $(fid).toggleClass("hide");
      return false;
    });

    $(".copy-ads").after('<span class="copied">Copied!</span>');
    $(".copy-ads").on("click", function () {
      var sid = $(this).data("source");
      let textarea = document.getElementById(sid);
      textarea.select();
      document.execCommand("copy");
      $(this).next(".copied").fadeIn().delay(2000).fadeOut();
      return false;
    });
  }

  function gdriveModal() {
    $('iframe[src*="drive.google"]').each(function () {
      var width = $(this).attr("width");
      $(this).wrap(
        '<div class="gdrive-video" style="max-width:' + width + 'px;"></div>'
      );
    });

    $('[data-fancybox="gdrive"]').each(function (index) {
      var $this = $(this);

      $(".gvids").append(
        '<div id="gdrive-' +
          index +
          '"><div class="gdrive-modal"><iframe src="' +
          $this.attr("href") +
          '" width="640" height="360"></iframe></div></div>'
      );

      $this.attr("href", "javascript:;");
      $this.attr("data-src", "#gdrive-" + index);
    });

    $('[data-fancybox="gdrive"]').fancybox({
      gutter: 0,
      infobar: false,
      baseClass: "fancy-gdrive",
      smallBtn: false,
      toolbar: "auto",
    });
  }

  function videoArts() {
    let video_page = 1;
    let article_page = 1;
    if ($(".video-arts").length) {
      $(".load-videos").on("click", function () {
        let $this = $(this),
          feed = $("#vid-feed");

        $this.parents(".col").addClass("loading");
        video_page++;

        $.get(
          "/blogs/videos?view=videos-ajax&page=" + video_page,
          function (data) {
            let content = data.trim();
            if (content.length) {
              console.log("load items");
              feed.append(content);
            } else {
              console.log("no items");
              $this.hide();
              feed.append(
                '<div class="item item-end"><h4>End of results.</h4></div>'
              );
            }
          }
        ).done(function () {
          $this.parents(".col").removeClass("loading");
          // console.log( 'total ' + $this.data('total') + ' -- video_page ' + ( video_page * parseInt( $this.data('limit') ) ) );
          if (
            $this.data("total") <=
            video_page * parseInt($this.data("limit"))
          ) {
            $this.hide();
          }
        });

        return false;
      });

      $(".load-articles").on("click", function () {
        let $this = $(this),
          feed = $("#art-feed");

        $this.parents(".col").addClass("loading");
        article_page++;

        $.get(
          "/blogs/articles?view=articles-ajax&page=" + article_page,
          function (data) {
            let content = data.trim();
            if (content.length) {
              console.log("load items");
              feed.append(content);
            } else {
              console.log("no items");
              $this.hide();
              feed.append(
                '<div class="item item-end"><h4>End of results.</h4></div>'
              );
            }
          }
        ).done(function () {
          $this.parents(".col").removeClass("loading");
          console.log(
            "total " +
              $this.data("total") +
              " -- article_page " +
              article_page * parseInt($this.data("limit"))
          );
          if (
            $this.data("total") <=
            article_page * parseInt($this.data("limit"))
          ) {
            $this.hide();
          }
        });

        return false;
      });

      $(".video-arts .search-form form").submit(function () {
        var $this = $(this);
        var values = $(this).serialize();
        var url = $this.attr("action") + "?" + values;
        var col = $this.parents(".col");
        var zero = col.find(".no-results");
        var target = col.find(".result-list");
        console.log(url);

        col.addClass("loading");
        target.empty().removeClass("visible");
        zero.removeClass("visible");

        if ($this.find("input").val().trim().length > 0) {
          $.get(url, function (data) {
            let content = data.trim();
            if (content.length) {
              // console.log( 'load items' );
              // console.log( content );
              // feed.append( content );
              target.append(content).addClass("visible");
            } else {
              // console.log( 'no items' );
              zero.addClass("visible");
            }
          }).done(function () {
            col.removeClass("loading");
          });
        } else {
          col.removeClass("loading");
        }

        return false;
      });
    }
  }

  $("body").on("DOMSubtreeModified", "#shopify-product-reviews", updateReviews);

  function productDetail() {
    if ($(".prod-detail").length && $(".prod-form").length) {
      if ($(window).width() > 955) {
        $(".prod-form").appendTo($(".prod-detail .figures"));
        $(".info .price").appendTo($(".prod-detail .figures"));
      }
    }
  }

  let isRegistration = false;
  let currentTags = ["public"];
  if ($(".acct-type").length) {
    isRegistration = true;
  }

  // var $returnTo = $(
  //   '<input type="hidden" name="return_to" value="/pages/thank-you-for-creating-a-practitioner-account" />'
  // );

  if (isRegistration) {
    $('.acct-type input[type="radio"]').on("click", function () {
      // console.log( $(this).attr('id') );
      let theID = $(this).attr("id");
      let extras = $("#extra-fields");
      // return false;
      extras.empty();

      $('[name="return_to"]').remove();

      if (theID == "acct-patient") {
        extras.empty();
        $(".is-patient").clone().appendTo(extras);
        currentTags = ["patient_pending"];

        // $returnTo = $(
        //   '<input type="hidden" name="return_to" value="/pages/thank-you-for-creating-a-patient-account" />'
        // );
        // $returnTo.insertBefore($('#RegisterForm input[type="submit"]'));
        sessionStorage.setItem("acct_type", "patient");
      } else if (theID == "acct-practitioner") {
        $(".is-practitioner").clone().appendTo(extras);
        currentTags = ["practitioner_pending"];

        // $returnTo = $(
        //   '<input type="hidden" name="return_to" value="/pages/thank-you-for-creating-a-practitioner-account" />'
        // );
        // $returnTo.insertBefore($('#RegisterForm input[type="submit"]'));
        sessionStorage.setItem("acct_type", "practitioner");
      } else {
        $(".is-public").clone().appendTo(extras);
        currentTags = ["public"];

        // $returnTo = $(
        //   '<input type="hidden" name="return_to" value="/pages/thank-you" />'
        // );
        // $returnTo.insertBefore($('#RegisterForm input[type="submit"]'));
        sessionStorage.setItem("acct_type", "public");
      }

      $("#customerTags").val(currentTags.join(" "));
    });

    $(document).on(
      "blur keyup change",
      "#extra-fields .input-text",
      getExtraFields
    );
  }

  function getExtraFields() {
    let type = $('.acct-type input[type="radio"]:checked').val();
    currentTags = [type];

    $("#extra-fields .input-text").each(function () {
      let thisValue = $(this).val().trim();
      let thisID = $(this).attr("id");

      if (thisValue != "") {
        if (thisID == "RegisterForm-referralCode") {
          currentTags.push("practitioner_referralcode:" + thisValue);
        } else if (thisID == "RegisterForm-practiceType") {
          currentTags.push("practitioner_practiceType:" + thisValue);
        } else if (thisID == "RegisterForm-licensesOrCollege") {
          currentTags.push("practitioner_license_or_College:" + thisValue);
        } else if (thisID == "RegisterForm-accessCode") {
          currentTags.push("patient_accesscode:" + thisValue);
        }
      }
    });
    // console.log( currentTags.join( ', ' ) );
    $("#customerTags").val(currentTags.join(", "));
  }

  function collectAnchor() {
    $(".collect-anchor").on("click", function () {
      let current_url = $(location).attr("href").split("#")[0],
        anchor_base_url = $(this).attr("href").split("#")[0],
        anchor_url = $(this).attr("href");
      // console.log( current_url + ' -- ' + anchor_url + ' -- ' + anchor_base_url );
      if (current_url == anchor_base_url) {
        runAnchor($(this).attr("href").split("#").pop());
      } else {
        window.location = anchor_url;
      }
      return false;
    });

    let detected_anchor = $(location).attr("href").split("#").pop();
    if (detected_anchor.indexOf("product-") >= 0) {
      setTimeout(runAnchor(detected_anchor), 1000);
    }
  }

  function runAnchor(anchor) {
    // console.log( 'run anchor -- ' + anchor );
    $("html, body").animate(
      {
        scrollTop: $('[data-product="' + anchor + '"]').offset().top,
      },
      600
    );
  }

  $(function () {
    bodyClass();
    menu();
    productDetail();
    slider();
    innateChoice();
    qty();
    prodWithUpsell();
    products();
    bulkOrders();
    account();
    gdriveModal();
    videoArts();
    updateBonusLIP();
    collectAnchor();
    checkLandingPage();

    $(".share").on("click", function () {
      $(this).toggleClass("active");
      return false;
    });

    $(document).on("click", "[data-cart-remove]", function () {
      setTimeout(function () {
        window.location = "/cart";
      }, 1000);
    });

    $(".active-lang").on("click", function () {
      $(this).parent().toggleClass("open");
      return false;
    });

    if ($(".acct-type").length || $(".template-captcha").length) {
      // var $returnTo = $('<input type="hidden" name="return_to" value="/pages/thank-you-for-creating-a-practitioner-account" />');
      var current_acct_type = sessionStorage.getItem("acct_type");
      if (!current_acct_type) {
        sessionStorage.setItem("acct_type", "practitioner");
      }

      if ($("#RegisterForm").length > 0) {
        //if registration form
        $returnTo.insertBefore($('#RegisterForm input[type="submit"]')); // add return_to input
      } else if ($("#g-recaptcha").length) {
        //if captcha form
        if (current_acct_type == "patient") {
          $returnTo = $(
            '<input type="hidden" name="return_to" value="/pages/thank-you-for-creating-a-patient-account" />'
          );
        } else if (current_acct_type == "practitioner") {
          // $returnTo = $(
          //   '<input type="hidden" name="return_to" value="/pages/thank-you-for-creating-a-practitioner-account" />'
          // );
        } else {
          // $returnTo = $(
          //   '<input type="hidden" name="return_to" value="/pages/thank-you" />'
          // );
        }
        // $returnTo.insertBefore(
        //   $('.shopify-challenge__container input[type="submit"]')
        // );
      }
    }

    if ($(".item-list").length) {
      if (
        $(".collection-parent-research-reviews-br-patient-newsletters").length
      ) {
        // $('.item-list .image .btn').removeClass('orange').addClass('blue');
        $(".item-list .text .btn.green").removeClass("green").addClass("blue");
      } else if ($(".collection-parent-exams-brreports").length) {
        // $('.item-list .image .btn').removeClass('orange').addClass('green');
      } else if ($(".collection-parent-innate-choicebr-supplements").length) {
        $(".item-list .text .btn.green")
          .removeClass("green")
          .addClass("orange");
      }
    }

    $(".print-page").click(function () {
      window.print();
      return false;
    });
  });

  function updateBonusLIP() {
    if ($(".template-cart").length) {
      $(".list-to-cart-free").on("click", function () {
        var $this = $(this),
          qty = $(this).prev().find("input").val();

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: {
            quantity: qty,
            id: $this.data("prod_id"),
            properties: {
              _bonus_item: "bonus-free-item",
            },
          },
          success: function () {
            window.location.href = "/cart";
            // console.log( 'redirecting by now........' );
            cartCount(); // update cart
          },
          error: function () {
            alter.log(
              "Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available."
            );
          },
        });
        return false;
      });
    }
  }

  function checkLandingPage() {
    // p80w.utils.setCookie("acct-type", "practitioner", 30);
    let acctType = p80w.utils.getCookie("acct-type");
    if (acctType != "practitioner" && $(".landing-temp").length) {
      $("body").addClass("landing-enable");
    }

    $(".landing-acct-type").on("click", function () {
      p80w.utils.setCookie("acct-type", "practitioner", 365);
      window.location.href = $(this).attr("href");
      return false;
    });
  }

  $(window).on("resize scroll", function () {
    if ($(".bulk-totals").length) {
      if ($(".bulk-totals:not(.sticky)").isInViewport()) {
        $(".bulk-totals.sticky").addClass("hidden");
        $(".arrow-down").hide();
      } else {
        $(".bulk-totals.sticky").removeClass("hidden");
        $(".arrow-down").show();
      }
    }

    if ($(".template-index").length) {
      if ($("#shopify-section-footer").isInViewport()) {
        $(".arrow-down").hide();
      } else {
        $(".arrow-down").show();
      }
    }
  });

  $(window).on("resize", function () {
    prodWithUpsell();
  });

  $(window).on("load", function () {
    prodWithUpsell();
    // updateReviews();
  });

  $(window).scroll(function () {});

  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
})(jQuery);
